import { CreditLineStatusEnum, EVENTS } from '@trnsact/trnsact-shared-types';

export enum VOStatus {
  Prospect = 'Prospect',
  PreQualified = 'Pre Qualified',
  Approved = 'Approved',
  Funded = 'Funded',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
}

export const stageOptions: { value: VOStatus; label: string }[] = [
  { value: VOStatus.Prospect, label: 'Prospect' },
  { value: VOStatus.PreQualified, label: 'Pre-Qualified' },
  { value: VOStatus.Approved, label: 'Approved' },
  { value: VOStatus.Funded, label: 'Funded' },
  { value: VOStatus.Cancelled, label: 'Cancelled' },
  { value: VOStatus.Declined, label: 'Declined' },
];

export const creditLineStatusOptions: { value: CreditLineStatusEnum; label: string }[] = Object.values(
  CreditLineStatusEnum
).map(status => ({
  value: status,
  label: status.toString(),
}));

export enum WorkflowEventType {
  VENDOR_OPPORTUNITY_UPDATED = 'VENDOR_OPPORTUNITY_UPDATED',
  CREDIT_LINE_STATUS_UPDATED = 'CREDIT_LINE_STATUS_UPDATED',
}

export const workflowEventOptions: { value: (typeof EVENTS)[keyof typeof EVENTS]; label: string }[] = [
  { value: EVENTS.VENDOR_OPPORTUNITY_UPDATED, label: 'Vendor Opportunity Updated' },
  { value: EVENTS.CREDIT_LINE_STATUS_UPDATED, label: 'Credit Line Status Updated' },
];

export enum WorkflowActionType {
  CREATE_TASK = 'CREATE_TASK',
  SEND_EMAIL = 'SEND_EMAIL',
}

export const workflowActionOptions: { value: WorkflowActionType; label: string }[] = [
  { value: WorkflowActionType.CREATE_TASK, label: 'Create Task' },
  { value: WorkflowActionType.SEND_EMAIL, label: 'Send Email' },
];
